'use client';

import {useState} from 'react';
import {X} from 'lucide-react';
import {Button} from '@manaboo/ui/button';
import {Switch} from '@manaboo/ui/switch';
import {useCookieConsent, type CookieConsent} from './cookie-context';

interface CookiePreferencesProps {
	onClose: () => void;
	onSave: (newConsent: CookieConsent) => void;
}

export function CookiePreferences({onClose, onSave}: CookiePreferencesProps) {
	const {consent} = useCookieConsent();
	const [preferences, setPreferences] = useState(
		consent ?? {
			necessary: true,
			analytics: false,
			marketing: false,
		},
	);

	const handleSave = () => {
		onSave(preferences);
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div className="bg-background relative w-full max-w-md rounded-lg border p-6">
				<Button
					variant="ghost"
					size="icon"
					className="absolute right-2 top-2"
					onClick={onClose}
					aria-label="Zamknij"
				>
					<X className="h-4 w-4" />
				</Button>

				<h2 className="mb-4 text-xl font-bold">Preferencje plików cookie</h2>

				<div className="space-y-4">
					<div className="flex items-center justify-between gap-5">
						<div>
							<span className="text-sm font-semibold">Niezbędne</span>
							<p className="text-muted-foreground text-xs">
								Wymagane do prawidłowego funkcjonowania strony.
							</p>
						</div>
						<Switch
							checked
							disabled
						/>
					</div>
					<div className="flex items-center justify-between gap-5">
						<div>
							<span className="text-sm font-semibold">Analityczne</span>
							<p className="text-muted-foreground text-xs">
								Pomagają nam ulepszyć naszą stronę poprzez zbieranie
								informacji o użytkowaniu.
							</p>
						</div>
						<Switch
							checked={preferences.analytics}
							onCheckedChange={(checked) => {
								setPreferences((prev) => ({...prev, analytics: checked}));
							}}
						/>
					</div>
					<div className="flex items-center justify-between gap-5">
						<div>
							<span className="text-sm font-semibold">Marketingowe</span>
							<p className="text-muted-foreground text-xs">
								Używane do dostarczania spersonalizowanych reklam.
							</p>
						</div>
						<Switch
							checked={preferences.marketing}
							onCheckedChange={(checked) => {
								setPreferences((prev) => ({...prev, marketing: checked}));
							}}
						/>
					</div>
				</div>
				<div className="mt-6 flex justify-end space-x-4">
					<Button
						variant="outline"
						onClick={onClose}
					>
						Anuluj
					</Button>
					<Button onClick={handleSave}>Zapisz preferencje</Button>
				</div>
			</div>
		</div>
	);
}
